export class NameInUseError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'NameInUseError';
    }
}
